// Author liang gang qiang
// Date 2023-11-13 11:23:40

import * as model from "@/model/sithMesII/plan/SithMomMainProjectPlanDetailModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMomMainProjectPlanDetail(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMESII_PLAN_URL,
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'sithMomMainProjectPlanDetail',
        modelFilter: model.filter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'levelTreeFilter',
        filterInitializer: newFilter
    })
    .buildStore()
